import { GlobalStyle } from '@ff/design-system';
import { posthog } from 'posthog-js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from 'styled-components';
import App from '@application/App';
import { getCspNonce } from '@shared/helpers/csp-nonce';
import { theme } from '@shared/theme';

import '@ff/design-system/public/assets/fonts/inter.css';
import '@images/favicon.ico';

// Reads the CSP nonce injected by Rails and passes it to webpack.
// This is required for `styled-components` which injects <style> tags at runtime
// and setting __webpack_nonce__ ensures those inline styles are compliant with strict CSP without using `unsafe-inline`.
// See: https://github.com/styled-components/styled-components/issues/887
const nonce = getCspNonce();
if (nonce) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  __webpack_nonce__ = nonce;
}

if (window.POSTHOG_PROJECT_PUBLIC_TOKEN) {
  posthog.init(window.POSTHOG_PROJECT_PUBLIC_TOKEN, {
    api_host: window.POSTHOG_API_URL,
    defaults: '2026-05-30',
    // https://practice.gto.tech.gov.sg/swe/handbook/reference/observability/product-analytics/#disable-sensitive-features
    autocapture: false,
    disable_session_recording: true,
    capture_performance: false,
    capture_heatmaps: false,
  });

  const user = window.FF_USER_INFO;
  const loggedIn = !!(user && 'posthog_distinct_id' in user);
  posthog.register({
    event_source: 'client',
    logged_in: loggedIn,
    deploy_env: window.POSTHOG_DEPLOY_ENV,
  });

  if (loggedIn && user && 'posthog_distinct_id' in user) {
    posthog.identify(user.posthog_distinct_id);
  }
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
